import { api } from './client.js';

/**
 * 상회칠판 (SPEC_CHANGE_v1.3 17장, D52). 날짜는 늘 한국 시각.
 * day 가 없으면 오늘 칠판(머리 · 칸 · 오늘 더 적힐 이야기 · 지난 칠판), day 면 그날 칸만, pastBefore 면 그 전 지난 칠판 줄만
 */
export function fetchBoard({ day, pastBefore, signal } = {}) {
    const params = new URLSearchParams();
    if (day) {
        params.set('day', day);
    }
    if (pastBefore) {
        params.set('pastBefore', pastBefore);
    }
    const query = params.toString();
    return api(`/board${query ? `?${query}` : ''}`, { signal });
}

/** 상회칠판 고민 칸: 내 고민(과 예전 단골 일상 글) 최신순 */
export function fetchWorries({ signal } = {}) {
    return api('/board/worries', { signal });
}

/**
 * 하루/고민 올리기. clientKey 는 한 번 보낼 때마다 새로 만들고, 같은 글을 다시 보낼 때는
 * 같은 값을 씁니다. 서버가 그것으로 같은 글이 두 번 생기지 않게 합니다.
 */
export function createPost({ kind, body, clientKey }) {
    return api('/posts', { method: 'POST', body: { kind, body, clientKey } });
}

export function fetchPost(postsId, { signal } = {}) {
    return api(`/posts/${postsId}`, { signal });
}

export function retryPost(postsId) {
    return api(`/posts/${postsId}/retry`, { method: 'POST' });
}

/** 위기 신호가 애매한 글에서 이모와의 1:1 로 (D17). 이모가 확인 질문으로 먼저 잇습니다 */
export function startCheckIn(postsId) {
    return api(`/posts/${postsId}/check-in`, { method: 'POST' });
}

/** 매일 콘텐츠에 공감·위로·응원. 다시 누르면 거둡니다 */
export function toggleReaction(dailyItemsId, kind) {
    return api(`/board/items/${dailyItemsId}/reactions`, { method: 'POST', body: { kind } });
}

/** 글 + 답글 (시안 05 S2a, D46) */
export function fetchThread(postsId, { signal } = {}) {
    return api(`/posts/${postsId}/thread`, { signal });
}

/** 단골 답글 · 대댓글. parentId 는 답하는 멤버 답글(없으면 글 전체에 붙는 답글) */
export function postReply(postsId, { text, parentId = null }) {
    return api(`/posts/${postsId}/replies`, { method: 'POST', body: { text, parentId } });
}

export function editPost(postsId, body) {
    return api(`/posts/${postsId}`, { method: 'PATCH', body: { body } });
}

export function deletePost(postsId) {
    return api(`/posts/${postsId}`, { method: 'DELETE' });
}

/** 멤버 일상 글 + 답글 (시안 05 S1b-c, D47) */
export function fetchMemberThread(memberPostsId, { signal } = {}) {
    return api(`/member-posts/${memberPostsId}/thread`, { signal });
}

/** 멤버 글에 답글. 대상이 없으면 글쓴이 멤버가 반드시 답합니다 */
export function postMemberReply(memberPostsId, { text, parentId = null }) {
    return api(`/member-posts/${memberPostsId}/replies`, { method: 'POST', body: { text, parentId } });
}
